export const getCookieByName = (name: string = "token"): string => {
  const cookies = document.cookie.split(';')

  let cookie = '';
  cookies.forEach(item => {
    const [ key, value ] = item.split('=');
    if(key.replace(' ', '') === name){
      cookie = value;
    }
  });

  return cookie;
}